const generateName = (arrayName, fieldName) => `${arrayName ? `${arrayName}.` : ''}${fieldName}`;

export { generateName };
